import { CustomElement } from '@aurelia/runtime-html';
import * as d0 from "@components/calendar/calendar-component-widget";
export const name = "calendar-component";
export const template = "\n\n<div class=\"font-raleway w-full min-w-80 md:min-w-[786px] section p-4\">\n  <div class=\"relative\">\n    <div class=\"flex flex-row items-center justify-between\">\n      <h5 t=\"dashboardcards.calendar\" class=\"text-large-medium text-gray-900 dark:text-gray-50\">Calendário de Marketing\n      </h5>\n      <div class=\"icon-box-md md:!hidden text-gray-700 dark:text-gray-200\">\n        <i class=\"mdi mdi-minus-circle-outline\"></i>\n      </div>\n    </div>\n\n    <div\n      class=\"${zeusClient.userDetails.onboardCompleted && zeusClient.userDetails.generatingNextMonthCalendarFromOnboard === null ? 'blur-sm pointer-events-none' : ''}\">\n      <calendar-component-widget hide-events=\"true\"></calendar-component-widget>\n    </div>\n\n  </div>\n</div>";
export default template;
export const dependencies = [ d0 ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
